// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import withStyles from '../../../hoc/withStyles';
import style from '../styles/TextBoxLoader.style';

class TextBoxLoader extends React.PureComponent {
  render() {
    const { className } = this.props;
    return (
      <div className={`${className} textbox-loader-cont`}>
        <div className="box loading js-loader-1" />
      </div>
    );
  }
}

export default withStyles(TextBoxLoader, style);
